module.exports = __webpack_public_path__ + "imgascvts/Floor.c3618abb.png";